class navExposure {
    navExposureProp = {
        "language": "en",
        "site": "com",
        "device_os": navigator.userAgent,
        "region": localStorage.getItem('T4Currency')? localStorage.getItem('T4Currency') : $('#nt_wrapper').data('currency') ? $('#nt_wrapper').data('currency') :'usd',
        "account_ident": localStorage.getItem('account_ident'),
        "platform": util.isMobile() ? 'm' : 'pc',
        "page_type": util.getPageType(),
    }
    exposureHandle(el, navi_name_l1, navi_name_l2 = '', navi_name_l3 = '', rank, nt_sid) {
        // console.log('navexposureHandle')
        const properties = {
            ...this.navExposureProp,
            navi_name_l1,
            navi_name_l2,
            navi_name_l3,
            rank,
            nt_sid
        }
        exposure.addExposureView(el, {
            eventName: "hw_exposure_navigation",
            config: {
                area_rate: 1,
                stay_duration: 1,
                repeated: false
            },
            properties,
            listener: { // 是否触发曝光事件
                shouldExpose: function (ele, properties) {
                    util.isMobile() ? '' : $(ele).parents('.nt_navigation_new').find('li.menu_item_hover .menu-parent-level1').addClass('isHover')
                    return true;
                },

                // 已触发曝光回调
                didExpose: function (ele, properties) {
                    exposure.removeExposureView(ele)
                }
            }
        });
        util.isMobile() ? $('body').addClass('navExposureHandle') : ''
    }
}


(function () {
    const navSa = new navExposure()
    $('.nt_navigation_new  .menu-parent-level1').map((x, i) => {
        let first = $(i).data('name');
        $(i).attr('data-sort', x)
        navSa.exposureHandle(i, first, '', '', x, 'navLevel_1')
    })

    $('.nt_navigation_new  .menu-parent-level1').hover(function () {
        // console.log($(this))
        console.log(!$(this).hasClass('isHover'))
        if (!$(this).hasClass('isHover')) {
            $(this).parents('.menu-item').find('.menu-children-level2').map((x, i) => {
                let first = $(i).parents('li.menu_default').find('.menu-parent-level1').data('name');
                let second = $(i).data('name');
                $(i).attr('data-sort', x)
                navSa.exposureHandle(i, first, second, '', x, 'navLevel_2')
            })
            $(this).parents('.menu-item').find('.menu-children-level3').map((x, i) => {
                let first = $(i).parents('li.menu_default').find('.menu-parent-level1').data('name');
                let second = $(i).parents('.sub_sub_link').siblings('.menu-children-level2').data('name');
                let third = $(i).data('name');
                let sort = $(i).data('sort')
                navSa.exposureHandle(i, first, second, third, sort, 'navLevel_3')
            })
        }
    })

    $('body').on('click', '.nt_navigation_new  .menu-parent-level1', function () {
        let navi_name_l1 = $(this).data('name');
        let rank = $(this).data('sort')
        let config = {
            navi_name_l1,
            rank,
            ...navSa['navExposureProp']
        }
        sensors.track('hw_click_navigation', config);
    })

    $('body').on('click', '.nt_navigation_new  .menu-children-level2', function () {
        let navi_name_l1 = $(this).parents('li.menu_default').find('.menu-parent-level1').data('name');
        let navi_name_l2 = $(this).data('name');
        let rank = $(this).data('sort')
        let config = {
            navi_name_l1,
            navi_name_l2,
            rank,
            ...navSa['navExposureProp']
        }
        sensors.track('hw_click_navigation', config);
    })

    $('body').on('click', '.nt_navigation_new  .menu-children-level3', function () {
        let navi_name_l1 = $(this).parents('li.menu_default').find('.menu-parent-level1').data('name');
        let navi_name_l2 = $(this).parents('.sub_sub_link').siblings('.menu-children-level2').data('name');
        let navi_name_l3 = $(this).data('name');
        let rank = $(this).data('sort')
        let config = {
            navi_name_l1,
            navi_name_l2,
            navi_name_l3,
            rank,
            ...navSa['navExposureProp']
        }
        sensors.track('hw_click_navigation', config);
    })

})()
